import CollectPayrixPaymentDialog from './CollectPayrixPaymentDialog'
export * from './CollectPayrixPaymentDialog'
export default CollectPayrixPaymentDialog
